import { render } from "./PagamentosClinicas.vue?vue&type=template&id=79218c1b&scoped=true"
import script from "./PagamentosClinicas.vue?vue&type=script&lang=js"
export * from "./PagamentosClinicas.vue?vue&type=script&lang=js"

import "./PagamentosClinicas.vue?vue&type=style&index=0&id=79218c1b&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79218c1b"]])

export default __exports__